var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatartwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#F7F2FE",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 17H10.2869V9.72727H12.6307C13.3362 9.72727 13.9399 9.87287 14.4418 10.1641C14.9437 10.4529 15.3284 10.8684 15.5959 11.4105C15.8634 11.9503 15.9972 12.5966 15.9972 13.3494C15.9972 14.107 15.8622 14.7592 15.5923 15.3061C15.3224 15.8506 14.9295 16.2696 14.4134 16.5632C13.8973 16.8544 13.2699 17 12.5312 17ZM11.1676 16.2188H12.4744C13.0758 16.2188 13.5741 16.1027 13.9695 15.8707C14.3648 15.6387 14.6596 15.3085 14.8537 14.88C15.0478 14.4515 15.1449 13.9413 15.1449 13.3494C15.1449 12.7623 15.049 12.2569 14.8572 11.8331C14.6655 11.407 14.379 11.0803 13.9979 10.853C13.6167 10.6233 13.142 10.5085 12.5739 10.5085H11.1676V16.2188Z",
    fill: "#9747FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatartwo);
export default __webpack_public_path__ + "static/media/Avatartwo.23524b9d2959da5ba33525973cf8e1b4.svg";
export { ForwardRef as ReactComponent };